export const getDietDisplayValue = (dietValue: string): string => {
  const dietMap: { [key: string]: string } = {
    '': 'default',
    Líquida: 'liquidDiet',
    Semilíquida: 'semiLiquidDiet',
    Blanda: 'softDiet',
    Astringente: 'astringentDiet',
    Absoluta: 'absoluteDiet',
  }
  return dietMap[dietValue] || dietValue
}
